import * as React from "react";
import { NavLink } from "react-router-dom";
import { getFirstAvailableSubMenuRoute } from "../../../../utils/navigationUtils";

const ItemsPaidSection = ({
  event,
  isParentMenuAvailable,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isMenuItemAvailable,
  completed_modules,
  in_array,
  t,
  menuHierarchy,
}) => {
  if (!(event && event.eventsite_setting && Number(event.eventsite_setting.payment_type) === 1 && isParentMenuAvailable("items_paid"))) return null;
  
  // Get the first available sub-menu route for items_paid
  const firstAvailableRoute = getFirstAvailableSubMenuRoute("items_paid", menuHierarchy);
  
  return (
    <li
      style={{ order: getParentMenuSortOrder("items_paid"), counterSet: `section ${getParentMenuDisplayNumber("items_paid")}` }}
      className={`${window.location.pathname.includes("event_site/billing-module") ? "bold activeList" : ""}`}
    >
      <span>
        <NavLink to={firstAvailableRoute || "/event_site/billing-module/payment-methods"}>{t("BILLING_BILLING_SETUP_MENU")}</NavLink>
      </span>
      <ul>
        {isMenuItemAvailable("payment_methods") && (
          <li>
            <NavLink to="/event_site/billing-module/payment-methods"><span className="active">{t("BILLING_PAYMENT_METHOD_MENU")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("payment_providers") && (
          <li className={event && event.eventsite_secion_fields && Number(event.eventsite_secion_fields.company_detail.credit_card_payment.status) === 1 ? "" : "lockscreen"}>
            <NavLink to="/event_site/billing-module/payment-providers"><span className="active">{t("BILLING_PAYMENT_PROVIDERS_MENU")}</span></NavLink>
          </li>
        )}
        {event && event.eventsite_payment_setting && Number(event.eventsite_payment_setting.billing_type) === 1 && isMenuItemAvailable("public") && (
          <React.Fragment>
            <li className={event && event.eventsite_secion_fields && Number(event.eventsite_secion_fields.company_detail.company_public_payment.status) === 1 ? "" : "lockscreen"}>
              <NavLink to="/event_site/billing-module/ean-invoice"><span className="active">{event && event.eventsite_secion_fields && event.eventsite_secion_fields.company_detail.company_public_payment.name ? event.eventsite_secion_fields.company_detail.company_public_payment.name : t("BILLING_EAN_MENU")}</span></NavLink>
            </li>
            
            {isMenuItemAvailable("fik") && (
              <li   className={event && event.eventsite_payment_setting && Number(event.eventsite_payment_setting.eventsite_billing_fik) === 1 ? "" : "lockscreen"}   >
                <NavLink to="/event_site/billing-module/fik-setting"><span className="active">{t("BILLING_FIK_MENU")}</span></NavLink>
              </li>
            )}
          </React.Fragment>
        )}
        {isMenuItemAvailable("items") && (
          <li>
            <NavLink to="/event_site/billing-module/items"><span className="active">{t("BILLING_ITEMS_MENU")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("voucher") && (
          <li>
            <NavLink to="/event_site/billing-module/voucher"><span className="active">{t("BILLING_VOUCHER_MENU")}</span></NavLink>
          </li>
        )}
        {isMenuItemAvailable("purchase_policy") && (
          <li>
            <NavLink to="/event_site/billing-module/purchase-policy"><span className="active">{t("BILLING_PURCHSE_POLICY_MENU")}</span></NavLink>
          </li>
        )}
        {/* Only show orders if it's actually in the items_paid children */}
        {menuHierarchy && menuHierarchy.find(section => 
          section.alias === "items_paid" && 
          section.children && 
          section.children.find(child => child.alias === "orders" && child.status === 1)
        ) && (
          <li>
            <NavLink to="/event_site/billing-module/manage-orders" isActive={(match, location) => {
            if (!location) return false;
            return location.pathname === '/event_site/billing-module/manage-orders' ||
                   location.pathname === '/event_site/billing-module/custom-export';
        }}>
            <span className='active'>{t('BILLING_VOUCHER_ORDERS')}</span>
          </NavLink>
        </li>
          
        )}


       {isMenuItemAvailable("registration_form_stats") && (
          <li>
            <NavLink to="/event_site/billing-module/registration_form/statsdashboard"><span className="active">{t("BILLING_REGISTRATION_FORM_MENU")}</span></NavLink>
          </li>
        )}
        
        {/* Only show waiting_list_orders if it's actually in the items_paid children */}
        {menuHierarchy && menuHierarchy.find(section => 
          section.alias === "items_paid" && 
          section.children && 
          section.children.find(child => child.alias === "waiting_list_orders" && child.status === 1)
        ) && (
          <li>
            <NavLink to="/event_site/billing-module/waiting-list-orders"><span className="active">{t("BILLING_WAITING_LIST_ORDERS")}</span></NavLink>
          </li>
        )}
      </ul>
    </li>
  );
};

export default ItemsPaidSection;
